/*
Gestión de submenús en dropdowns
https://www.bootply.com/92442
*/
/* global $ */
// eslint-disable-next-line import/prefer-default-export
export function conectarSubmenus($el) {
  $el.find('ul.dropdown-menu [data-toggle=dropdown]').on('click', function onClick(event) {
    const $this = $(this);
    // Avoid following the href location when clicking
    event.preventDefault();
    // Avoid having the menu to close when clicking
    if (!($this.data('propagation') === false)) {
      event.stopPropagation();
    }

    // If a menu is already open we close it
    $this.closest('ul.dropdown-menu').find('[data-toggle=dropdown]').parent().removeClass('open');
    // opening the one you clicked on
    $this.parent().addClass('open');

    const menu = $this.parent().find("ul");
    const menupos = menu.offset();
    let newpos = menupos;

    if ((menupos.left + menu.width()) + 30 > $(window).width()) {
      newpos = -menu.width();
    } else {
      newpos = $this.parent().width();
    }
    menu.css({
      left: newpos,
    });
  });
}
